import React from "react";

export const Sales = () => {
  return <div>Sales</div>;
};
